import { TriangleAlert } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

/**
 * Surfaces the server's incomplete-address warnings (legacy `qc_client` /
 * `check_profile`). Renders nothing when the address passes QC. The warnings
 * reflect the last-saved address, so they update after a profile save.
 */
export function AddressQcBanner({ warnings }: { warnings: string[] }) {
  if (!warnings.length) return null;
  return (
    <Alert>
      <TriangleAlert />
      <AlertTitle>Address needs attention</AlertTitle>
      <AlertDescription>
        <ul className="list-disc pl-4">
          {warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}
